import CryptoJS from "crypto-js";

// Replace 'SECRET_KEY' with your secret key for encryption
// const SECRET_KEY = "R00M0FR#QU|R#M#NT";
const SECRET_KEY = "K!S@))W^M^&CL0A00X";

// Encrypt data
export const encryptData = (data) => {
    const ciphertext = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        SECRET_KEY
    ).toString();
    return ciphertext;
};

// Decrypt data
export const decryptData = (ciphertext) => {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
};
